const getters = {
	// 用戶TOKRN
	token: state => state.member.token,
	lang: state => state.app.lang,
	city: state => state.app.city,
	locationRegion: state => state.app.locationRegion,
	// 自動登錄時長
	autoLoginRange: state => state.member.autoLoginRange,
	wapQrcode: state => state.site.siteQrCode,
	// 會員詳情
	member: state => state.member.member,

	// 會員自動登錄時長
	autoLoginRange: state => state.member.autoLoginRange,

	copyRight: state => state.site.copyRight,
	siteInfo: state => state.site.siteInfo,
	addonIsExit: state => state.site.addons,

	// 購物車商品總數
	cartCount: state => state.cart.cartCount,
	// 進貨單商品總數
	wholesaleCartCount: state => state.wholesaleCart.wholesaleCartCount,

	defaultGoodsImage: state => state.site.defaultFiles.default_goods_img,
	defaultHeadImage: state => state.site.defaultFiles.default_headimg,
	defaultShopImage: state => state.site.defaultFiles.default_shop_img,

	// 普通待付款訂單
	orderCreateGoodsData: state => state.order.orderCreateGoodsData,

	//團購待付款訂單
	groupbuyOrderCreateData: state => state.order.groupbuyOrderCreateData,

	//秒殺待付款訂單
	seckillOrderCreateData: state => state.order.seckillOrderCreateData,

	//組合套餐待付款訂單
	comboOrderCreateData: state => state.order.comboOrderCreateData,
	
	//積分套餐待付款訂單
	pointsOrderCreateData: state => state.order.pointsOrderCreateData
}

export default getters;
